export type AuthorityType =
    | 'ROLE_ADMIN'
    | 'ROLE_SETUP'
    | 'ROLE_SYNC'
    | 'ROLE_ISSUES'
    | 'ROLE_REPORTS'
    | 'ROLE_BIM360_ADMIN';
export type ApplicationType = 'SYNC' | 'SETUP' | 'REPORTS' | 'ADMIN';
export type PageType =
    | 'home'
    | 'settings'
    | 'users'
    | 'projectMembers'
    | 'projectIssues'
    | 'projectSubmissions'
    | 'members'
    | 'connections'
    | 'files'
    | 'reports'
    | 'tasks';
export type ProviderType = 'BIM360' | 'WORKDOCS';
export type DataNodeType = 'HUB' | 'PROJECT' | 'FOLDER';
export type CustomAttributeDefinitionType = 'string' | 'date' | 'array';

export const statuses = ['ENABLED', 'DISABLED'] as const;
export type StatusType = typeof statuses[number];

export const memberTypes = ['ADMIN', 'USER'] as const;
export type MemberType = typeof memberTypes[number];

export const bim360Statuses = ['active', 'inactive', 'pending', 'not_invited'] as const;
export type Bim360Status = typeof bim360Statuses[number];

export const accesses = ['none', 'user', 'admin'] as const;
export type AccessType = typeof accesses[number];

export const serviceTypes = [
    'projectAdministration',
    'documentManagement',
    'projectManagement',
    'modelCoordination',
    'fieldManagement',
    'costManagement',
    'quantification',
    'assets',
    'designCollaboration',
    'insight',
] as const;
export type ServiceType = typeof serviceTypes[number];

export const frequencies = ['DAILY', 'WEEKLY', 'MONTHLY', 'ANNUALLY'] as const;
export type FrequencyType = typeof frequencies[number];

export const taskTypes = [
    'SYNC',
    'MEMBER_COMPANY_UPDATE',
    'MEMBER_STATUS_UPDATE',
    'MEMBER_COST_CENTER_UPDATE',
    'MEMBER_IMPORT',
    'PROJECT_MEMBER_COMPANY_UPDATE',
    'PROJECT_MEMBER_ROLES_UPDATE',
    'PROJECT_MEMBER_IMPORT',
    'PROJECT_MEMBER_DELETE',
    'PROJECT_ISSUES_COPY',
] as const;
export type TaskType = typeof taskTypes[number];

export const taskStatusTypes = ['CREATED', 'IN_PROGRESS', 'SYNCHRONIZING', 'SUCCESSFUL', 'ERROR', 'FAILED'] as const;
export type TaskStatusType = typeof taskStatusTypes[number];

export const entityStatusErrorTypes = [
    'CONNECTION_NOT_SUPPORTED',
    'SOURCE_FOLDER_NOT_FOUND',
    'SOURCE_FILE_NOT_FOUND',
    'SOURCE_FILE_TYPE_NOT_ALLOWED',
    'TARGET_FOLDER_NOT_FOUND',
    'TARGET_FOLDER_NOT_AUTHORIZED',
    'TOO_MANY_REQUESTS',
    'CONNECTION_NOT_SUPPORTED',
    'SOURCE_FOLDER_NOT_FOUND',
    'SOURCE_FILE_NOT_FOUND',
    'SOURCE_FILE_TYPE_NOT_ALLOWED',
    'TARGET_FOLDER_NOT_FOUND',
    'TARGET_FOLDER_NOT_AUTHORIZED',
    'MEMBER_DUPLICATE',
    'EMAIL_INVALID',
    'PROJECT_MEMBER_DUPLICATE',
    'PROJECT_ISSUE_DUPLICATE',
    'PROJECT_ISSUE_TYPE_NOT_FOUND',
    'PROJECT_ISSUE_SUBTYPE_NOT_FOUND',
    'PROJECT_ISSUE_STATUS_NOT_VALID',
] as const;
export type EntityStatusErrorType = typeof entityStatusErrorTypes[number];

export const projectTypes = ['SELF_DEVELOPED', 'LEASED_BUILDING'] as const;
export type ProjectType = typeof projectTypes[number];

export const projectSubmissionDesignTemplateTypes = ['ARS', 'TNS', 'IXD', 'AMZL', 'BLD'] as const;
export type ProjectSubmissionDesignTemplateType = typeof projectSubmissionDesignTemplateTypes[number];

export const projectSubmissionStates = ['DRAFT', 'SUBMITTED', 'APPROVED', 'REJECTED'] as const;
export type ProjectSubmissionState = typeof projectSubmissionStates[number];

export const projectIssueStatuses = [
    'answered',
    'closed',
    'draft',
    'in_dispute',
    'not_approved',
    'open',
    'ready_to_inspect',
    'void',
    'work_completed',
] as const;
export type ProjectIssueStatus = typeof projectIssueStatuses[number];
